import React from 'react';

import { Header } from 'modules/checkout/presentation/components/molecules';
import { AllRightsFooter } from 'shared/presentation/components/atoms';
import { FullPageLoading } from 'shared/presentation/components/molecules';

const CheckoutLoading: React.FC = () => {
  return (
    <>
      <Header />

      <FullPageLoading type="flex" />

      <AllRightsFooter />
    </>
  );
};

export default CheckoutLoading;
